var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiSmpGptAgent {
}
ApiSmpGptAgent.list = (query) => apiRequest({
    endpoint: REACT_APP__URL_SMP_API + "/gpt/v1/agent/",
    method: "GET",
    query,
});
ApiSmpGptAgent.create = (body) => apiRequest({
    body,
    endpoint: REACT_APP__URL_SMP_API + "/gpt/v1/agent/",
    method: "POST",
});
ApiSmpGptAgent.patch = (_a) => {
    var { id } = _a, body = __rest(_a, ["id"]);
    return apiRequest({
        body,
        endpoint: REACT_APP__URL_SMP_API + "/gpt/v1/agent/" + id,
        method: "PATCH",
    });
};
ApiSmpGptAgent.delete = (id) => apiRequest({
    endpoint: REACT_APP__URL_SMP_API + "/gpt/v1/agent/" + id,
    method: "DELETE",
});
//# sourceMappingURL=agent.js.map